module.exports = __webpack_public_path__ + "img/gb9115_21_a.prt.9c1f3f42.jpg";